






























import { Component, Vue } from "vue-property-decorator";
import { SolutionsUsingPowerPlan } from "@/services/powerPlans/types";
@Component
export default class PowerPlanDeleteNotAllowedModal extends Vue {
    SolutionsUsingPowerPlan = [] as SolutionsUsingPowerPlan[];
    // methods
    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") {
            this.close();
        }
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.SolutionsUsingPowerPlan = [];
    }

    open(data: SolutionsUsingPowerPlan[]) {
        this.SolutionsUsingPowerPlan = data;
        this.$bvModal.show("modal-powerPlanDeleteNotAllowedModal");
        window.addEventListener("keydown", this.handleEnter);
    }

    close() {
        this.$bvModal.hide("modal-powerPlanDeleteNotAllowedModal");
    }
}
